import React from 'react';
import VisitOrderBoard from './VisitOrderBoard';
import ReceiptModal from './modal/ReceiptModal';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

/** Orden de visitas del día. */
const VisitOrderList: React.FC<ShowAlerts> = ({ showLoading, hideLoading }) => (
  <VisitOrderBoard showLoading={showLoading} hideLoading={hideLoading} Receipt={ReceiptModal} />
);

export default VisitOrderList;
